export const SEND_TIME_TOO_FAR_IN_PAST = 'SequenceError.SEQUENCE_SEND_TIME_TOO_FAR_IN_PAST';